angular.module("ainapp")
    .controller("addticketController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {




            $scope.PageName = "Add Ticket";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.Init = function () {
                $scope.Bank = {
                    Priority: "",
                    SupportCategoryId: "",
                    Subject: "",
                    Details: "",
                    Code: "",
                }

                $scope.CompanyProfile = {};
                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;
                    $scope.Bank.Code = $scope.CompanyProfile.CustomerCode;
                })

                $scope.load = 0;

            }
            $scope.Init();



            $scope.Categories = [];
            MainService.getTicketCategories().then(function (response) {
                $scope.Categories = response.data;
            })



            $scope.AddData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.Bank.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.Bank.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");
                } else if ($scope.Bank.Priority == "") {
                    toastr.warning("Choose Priority");
                } else if ($scope.Bank.SupportCategoryId == "") {
                    toastr.warning("Choose Category");
                } else if ($scope.Bank.Subject == "") {
                    toastr.warning("Enter Subject");
                } else if ($scope.Bank.Details == "") {
                    toastr.warning("Enter Details");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddTicket($scope.Bank).then(function (response) {
                        if (response.data == "Success") {
                            toastr.success("Ticket Send Successfully, We Will Connect You Soon.");
                            $scope.Init();
                            $state.go("tickets");
                        } else {
                            toastr.error(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }


            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.Bank.FilePath = objXhr.responseText.substring(1, objXhr.responseText.length - 1);
                            if ($scope.Bank.FilePath.includes("error")) {
                                $scope.Bank.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                $scope.Bank.FilePath = objXhr.responseText.substring(1, objXhr.responseText.length - 1);
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", "https://api-management.magtec.ae/UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }


                }])
